export type FileUploaded = {
    name: string;
    url: string;
};

export function downloadFile(filename: string, fileType: string, body: string) {
    const blob = new Blob([body], {type: fileType});
    const link = document.createElement('a');
    if (link.download !== undefined) { // feature detection
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export function downloadCsv(filename: string, body: string, fileType = 'text/csv;charset=utf-8;') {
    downloadFile(filename, fileType, body);
}

export function downloadTxt(filename: string, body: string, fileType = 'text/plain;charset=utf-8;') {
    downloadFile(filename, fileType, body);
}

